<div *ngIf="organisationSpecificStep && addStepForm != null">
  <form [formGroup]="addStepForm" autocomplete="off" (ngSubmit)="saveStep(addStepForm.value)">
    <p-card>
      <div>
        <div class="ui-g-12">
          <input
            [attr.disabled]="selectedChecklist.locked ? true : null"
            pInputText
            id="name"
            formControlName="name"
            placeholder="Name"
            maxlength="250"
            class="ui-g-12"
          />
        </div>
        <br />
        <div class="ui-g-12">
          <textarea
            [attr.disabled]="selectedChecklist.locked ? true : null"
            pInputText
            id="description"
            rows="2"
            placeholder="Description"
            maxlength="250"
            class="ui-g-12"
            formControlName="description"
          ></textarea>
        </div>
        <div class="ui-g-12">
          <p-checkbox
            [disabled]="selectedChecklist.locked"
            formControlName="isStep"
            binary="true"
            label="User must indicate action is complete?"
          ></p-checkbox>
        </div>
        <p-fieldset legend="Text">
          <div class="ui-g-5 pt-0">
            <p-checkbox
              [disabled]="selectedChecklist.locked"
              formControlName="allowFreeText"
              binary="true"
              label="Allow Free Text?"
              (ngModelChange)="changedFreeText()"
            ></p-checkbox>
          </div>
          <div class="ui-g-7 pt-0">
            <p-dropdown
              [disabled]="selectedChecklist.locked || f.allowFreeText == false"
              formControlName="freeTextTypeId"
              placeholder="Free Text Type"
              [options]="freeTextTypes"
              class="ui-g-6 ui-sm-12 no-padding"
            ></p-dropdown>
            <input
              [attr.disabled]="selectedChecklist.locked || f.allowFreeText == false ? true : null"
              pInputText
              formControlName="placeholderText"
              placeholder="Placeholder Text"
              class="ui-g-6 ui-sm-12"
            />
            <p-checkbox
              [disabled]="selectedChecklist.locked || f.allowFreeText == false"
              formControlName="isFreeTextMandatory"
              binary="true"
              label="Response is Mandatory"
              class="ui-g-12 no-padding mt-2"
            ></p-checkbox>
          </div>
        </p-fieldset>
        <p-fieldset legend="Photographs" styleClass="fieldset">
          <div class="ui-g-12 pt-0">
            <div class="ui-g-5 pt-0">
              <p-checkbox
                [disabled]="selectedChecklist.locked"
                formControlName="allowPhotos"
                binary="true"
                label="Allow Photographs"
                class="ui-g-12 no-padding"
                (onChange)="handleAllowPhotosChange($event)"
              ></p-checkbox>
            </div>
            <div class="ui-g-7 pt-0">
              <label for="minPhotos">Minimum Photos Required: </label>
              <input
                [attr.disabled]="selectedChecklist.locked || f.allowPhotos == false ? true : null"
                pInputText
                type="number"
                id="minPhotos"
                formControlName="minPhotosAllowed"
                placeholder="Minimum Photos"
                class=""
              />
            </div>
          </div>
        </p-fieldset>
        <p-fieldset legend="Choice Selection" class="no-padding">
          <div class="ui-g-12">
            <div class="ui-g-5 pt-0">
              <p-checkbox
                [disabled]="selectedChecklist.locked"
                formControlName="isQuestion"
                binary="true"
                label=" Enable Choice Selection "
              ></p-checkbox>
            </div>
            <div class="ui-g-7 pt-0">
              <p-checkbox
                [disabled]="selectedChecklist.locked || !f.isQuestion"
                formControlName="isMultiChoiceSelection"
                binary="true"
                label="Is Multichoice Selection?"
              ></p-checkbox>
            </div>

            <div class="mt-6">
              <input
                [attr.disabled]="selectedChecklist.locked || !f.isQuestion ? true : null"
                [ngModelOptions]="{ standalone: true }"
                name="newAnswerText"
                type="text"
                pInputText
                placeholder="New Answer"
                class="ui-g-8"
                [(ngModel)]="newAnswerText"
              />
              <button
                [disabled]="selectedChecklist.locked || !f.isQuestion"
                pButton
                type="button"
                class="ui-button-raised ui-button-rounded"
                icon="fa fa-plus"
                label="Add"
                (click)="addAnswerToStep()"
              ></button>
            </div>
            <div class="clearfix"></div>
            <div
              *ngIf="
                organisationSpecificStep.answerTemplates != null &&
                organisationSpecificStep.answerTemplates.length > 0
              "
              class="mt-4"
            >
              <p-table [value]="sortedAnswerTemplates(organisationSpecificStep.answerTemplates)">
                <ng-template pTemplate="header">
                  <tr>
                    <th></th>
                    <th>Allow Photos</th>
                    <th>Min# Photos</th>
                    <th>Required?</th>
                    <th style="width: 50px"></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
                  <tr>
                    <td style="padding-left: 7px">
                      {{ data.displayOrder }})&nbsp;
                      <input
                        [attr.disabled]="selectedChecklist.locked ? true : null"
                        pInputText
                        type="text"
                        placeholder="1"
                        [(ngModel)]="data.answer.text"
                        [ngModelOptions]="{ standalone: true }"
                        name="text"
                        (input)="data.answer.id = 0"
                      />
                    </td>
                    <td class="text-center">
                      <p-checkbox
                        [disabled]="selectedChecklist.locked"
                        binary="true"
                        [(ngModel)]="data.allowPhotos"
                        [ngModelOptions]="{ standalone: true }"
                        name="allowPhotos"
                      ></p-checkbox>
                    </td>
                    <td>
                      <input
                        [disabled]="selectedChecklist.locked"
                        pInputText
                        type="number"
                        placeholder="0"
                        class="ui-g-12"
                        [(ngModel)]="data.minimumNumberOfPhotos"
                        [ngModelOptions]="{ standalone: true }"
                        name="minimumNumberOfPhotos"
                      />
                    </td>
                    <td>
                      <p-checkbox
                        [disabled]="selectedChecklist.locked"
                        binary="true"
                        [(ngModel)]="data.required"
                        [ngModelOptions]="{ standalone: true }"
                        name="required"
                      ></p-checkbox>
                    </td>
                    <td>
                      <i
                        class="fa ui-icon-trash link red"
                        (click)="
                          handleAnswerDelete(organisationSpecificStep.id, data.answerId, rowIndex)
                        "
                      ></i>
                    </td>
                  </tr>
                </ng-template>
              </p-table>

              <div *ngIf="hasInvalidSingleAnswerRequiredCombo()" class="pl-3 pt-2">
                <strong style="color: #c00"
                  >Answers can only be required when multichoice selection is enabled. Tick "Is
                  Multichoice Selection?" or untick the required answers.</strong
                >
              </div>

              <div *ngIf="!uniqueAnswerNames()" class="pl-3 pt-2">
                <strong style="color: #c00"
                  >All answer names must be unique. Please correct the errors.</strong
                >
              </div>

              <!-- DATATABLE DEPRECATED ---
                <p-dataTabl [value]="organisationSpecificStep.answerTemplates">
                  <p-column [editable]="tru">
                    <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                      <input [attr.disabled]="selectedChecklist.locked ? true : null" pInputText type="text" placeholder="1" class="ui-g-12" [(ngModel)]="data.answer.text" [ngModelOptions]="{standalone: true}" name="text" (input)="data.answer.id = 0"/>
                    </ng-template>
                  </p-column>
                  <p-column header="Allow Photos" styleClass="text-center" [editable]="tru">
                    <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                      <p-checkbox [disabled]="selectedChecklist.locked" binary="true" [(ngModel)]="data.allowPhotos" [ngModelOptions]="{standalone: true}" name="allowPhotos"></p-checkbox>
                    </ng-template>
                  </p-column>
                  <p-column header="Min # Photos" styleClass="text-center" [editable]="tru">
                    <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                      <input [disabled]="selectedChecklist.locked" pInputText type="number" placeholder="0" class="ui-g-12" [(ngModel)]="data.minimumNumberOfPhotos" [ngModelOptions]="{standalone: true}" name="minimumNumberOfPhotos"/>
                    </ng-template>
                  </p-column>
                  <p-column styleClass="text-center">
                    <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                      <i class="fa ui-icon-trash link red" (click)="handleAnswerDelete(organisationSpecificStep.id, data.answerId, ri)"></i>
                    </ng-template>
                  </p-column>
              </p-dataTable>
              --->
            </div>
          </div>
        </p-fieldset>

        <p-fieldset legend="Ancillary Step" class="no-padding">
          <div class="ui-g-12">
            <div class="ui-g-5 pt-0">
              <span>Select Ancillary Step</span>
            </div>
            <div class="ui-g-7 pt-0">
              <p-dropdown
                formControlName="ancillaryStepId"
                [options]="ancillarySteps"
                appendTo="body"
                placeholder="Ancillary steps"
                autoWidth="false"
                [style]="{ width: '100%' }"
              >
              </p-dropdown>
            </div>
          </div>
        </p-fieldset>
      </div>
      <p-footer>
        <div class="">
          <div class="ui-g-12">
            <p-checkbox
              [disabled]="selectedChecklist.locked"
              formControlName="hasPII"
              binary="true"
              label="Contains Personal Identifiable Data (GDPR)"
            ></p-checkbox>
          </div>
          <div style="float: right">
            <button
              type="button"
              pButton
              icon="fa fa-times"
              label="Cancel"
              (click)="handleCloseDialog()"
            ></button>
            <button
              type="submit"
              class="green-btn"
              pButton
              icon="fa fa-check"
              label="Save"
              [disabled]="
                selectedChecklist.locked || !addStepForm.valid || isBusy || !uniqueAnswerNames()
              "
            ></button>
          </div>
          <div class="clearfix"></div>
        </div>
      </p-footer>
    </p-card>
  </form>
</div>
<p-confirmDialog
  key="confirmAction"
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ position: 'absolute', top: '50%', left: '50%', width: '425px' }"
  acceptLabel="Yes"
  rejectLabel="No"
  appendTo="body"
></p-confirmDialog>
